module.exports = __webpack_public_path__ + "static/googlePlay-b3672a2c88015ef732663eda18dccc1d.svg";